export default __webpack_public_path__ + "static/media/exit-white.068bda4b.svg";